export default __webpack_public_path__ + "static/media/purchaseAction.4330c8a2.svg";